export default __webpack_public_path__ + "static/media/ic_delivery.1231a926.svg";